export default "__VITE_ASSET__mCvBc2JH__"